/** Untracked and continue-selling variants return null so an increase is never blocked. */
export function getInventoryLimit (item) {
  if (!item?.inventory_management) return null
  if (item.inventory_policy === 'continue') return null
  return item.inventory_quantity
}

/** True only when a requested increase exceeds genuinely tracked stock. */
export function exceedsInventory (item, newQuantity) {
  const limit = getInventoryLimit(item)
  return newQuantity > 0 && limit !== null && newQuantity > limit
}
